"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "IComponentClassNamesGenerator", {
  enumerable: true,
  get: function get() {
    return _generateComponentClassNames.IComponentClassNamesGenerator;
  }
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _generateComponentClassNames2["default"];
  }
});
var _generateComponentClassNames = require("./generateComponentClassNames.types");
var _generateComponentClassNames2 = _interopRequireDefault(require("./generateComponentClassNames"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}